module.exports = __webpack_public_path__ + "static/media/cloud.a0a139ff.webp";